const constants = {
  title: "Negocios",
  createStore: "Crear negocio",
  summary: (filtered: number, total: number) => `Mostrando ${filtered} negocios de ${total}`,
};

export default constants;
